// extracted by mini-css-extract-plugin
module.exports = {"warning":"WarningText_warning__3rqE4","danger":"WarningText_danger__oBsB6"};